export default function ArrowRightIcon(props) {
    return (
        <svg width={props.width || "25"} height={props.height || "24"} viewBox="0 0 25 24" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
            <path fill={props?.fill || "#fff"} d="M10.0309 4.27436L16.845 11.3854C17.0105 11.5567 17.0927 11.7789 17.0927 12C17.0927 12.2211 17.0105 12.4433 16.845 12.6146L10.0309 19.7256C9.6919 20.081 9.12938 20.0926 8.77523 19.7523C8.41875 19.4143 8.40716 18.8495 8.7486 18.4965L14.9726 12L8.7486 5.50351C8.40716 5.15166 8.41875 4.58569 8.77523 4.24773C9.12938 3.90747 9.6919 3.91903 10.0309 4.27436Z" />
        </svg>
    )
}
